import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/david/clawd/localauthority/app/layouts/default.vue").then(m => m.default || m))
}